// https://firebase.google.com/docs/reference/js/v9/FirestoreHandler_

import {
  getFirestore,
  collection,
  doc,
  addDoc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  onSnapshot,
  orderBy,
} from 'firebase/firestore'

const db = getFirestore()

const FirestoreHandler = {

}

FirestoreHandler.add = (collectionPath, data) => {
  return addDoc(collection(db, collectionPath), data)
}

FirestoreHandler.set = (collectionPath, docPath, data) => {
  return setDoc(doc(db, collectionPath, docPath), data)
}

FirestoreHandler.update = (collectionPath, docPath, data) => {
  return updateDoc(doc(db, collectionPath, docPath), data)
}

FirestoreHandler.query = async ({ collectionPath, order, f, cb }) => {
  let q
  if (f) {
    q = query(
      collection(db, collectionPath),
      orderBy(order.field, order.order),
      where(f.field, f.operator, f.value)
    )
  } else { q = query(collection(db, collectionPath), orderBy(order.field, order.order)) }

  return onSnapshot(q, snapshot => {
    cb(snapshot.docs.map(doc => doc.data()))
  })
}

FirestoreHandler.get = async (collectionPath, docPath, raw) => {
  const docSnap = await getDoc(doc(db, collectionPath, docPath))

  // IF !docSnap.exists() doc.data = undefined
  if (raw) return docSnap

  return docSnap.data()
}

FirestoreHandler.getCollection = async (collectionPath, args = {}) => {
  const { where: collectionFilter, sort, map, filter, raw } = args

  let q
  if (collectionFilter && Array.isArray(collectionFilter)) {
    const filterArgs = [collection(db, collectionPath)]

    collectionFilter.forEach(f => {
      if (!f.field) return
      if (!f.value) return
      if (!f.operator) f.operator = '=='

      filterArgs.push(where(f.field, f.operator, f.value))
    })
    // Call function query dynamic with filter args
    q = query.apply(null, filterArgs)
  } else {
    q = collection(db, collectionPath)
  }

  const querySnapshot = await getDocs(q)

  if (raw) return querySnapshot

  let filteredDocs
  if (map) {
    filteredDocs = querySnapshot.docs.map(map)
  } else {
    filteredDocs = querySnapshot.docs.map(doc => doc.data())
  }

  if (sort) {
    filteredDocs = filteredDocs.sort(sort)
  }

  return filter ? filteredDocs.filter(filter) : filteredDocs
}

FirestoreHandler.subscribe = async ({ collectionPath, docPath }, cb) => {
  if (!collectionPath) throw Error('collectionPath is undefinded')
  if (!cb) throw Error('Callback undefinded')

  let unsubLink

  if (docPath) {
    const q = query(doc(db, collectionPath, docPath))

    unsubLink = onSnapshot(q, snapshot => {
      cb(snapshot)
    })
  } else {
    const q = query(collection(db, collectionPath))
    unsubLink = onSnapshot(q, snapshot => {
      cb(snapshot)
    })
  }

  return unsubLink
}

FirestoreHandler.unsubscribe = subLink => {
  if (!subLink) throw Error('Subscription link undefinded')

  subLink()
}

export default FirestoreHandler
